import React, { useState } from 'react';
import { useStateContext } from '../contexts/ContextProvider';

const Button = ({
	color,
	bgColor,
	icon,
	text,
	borderRadius,
	bgHoverColor,
	size,
	width,
}) => {
	const { setIsClicked, initialState } = useStateContext();
	return (
		<button
			type='button'
			onClick={() => setIsClicked(initialState)}
			style={{ backgroundColor: bgColor, color, borderRadius }}
			className={` text-${size} p-3 w-${width} hover:drop-shadow-xl hover:bg-${bgHoverColor}`}
		>
			{icon} {text}
		</button>
	);
};

export const ActionButton = ({ onClick, icon: Icon, className, tooltip }) => {
	const [showTooltip, setShowTooltip] = useState(false);

	return (
		<div className="relative">
			<button
				type="button"
				onClick={onClick}
				className={`p-2 border rounded-full hover:shadow-md transition-all duration-200 ${className}`}
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
			>
				<Icon size={16} />
			</button>

			{/* {showTooltip && tooltip && (
				<div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs font-medium text-white bg-gray-800 rounded-md shadow-md whitespace-nowrap z-10">
					{tooltip}
					<div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
				</div>
			)} */}
		</div>
	);
};

export default Button;
